var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DataImg',{attrs:{"type":"avatar","name":_vm.name,"lazy":_vm.lazy}})
}
var staticRenderFns = []

export { render, staticRenderFns }